import React, { useRef, useState, useEffect, memo } from 'react';
import { Typography, Tooltip } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

type TruncatedTextProps = {
  text: string;
  sx?: SxProps<Theme>;
};

const TruncatedText = memo(({ text, sx }: TruncatedTextProps) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (!element) return;

    setIsTruncated(element.scrollWidth > element.clientWidth);
  }, [text]);

  const typography = (
    <Typography
      ref={textRef}
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      {text}
    </Typography>
  );

  if (!isTruncated) {
    return typography;
  }

  return (
    <Tooltip title={text} arrow placement="left">
      {typography}
    </Tooltip>
  );
});

TruncatedText.displayName = 'TruncatedText';

export default TruncatedText;
